import { FetchWrapper } from "../infrastructure/fetch-wrapper";
import { modelServices } from "./ah.mb.ui.model-services";
import { IBasicCommandResponse } from "./ah.mb.client-notifications";
import { NodeObject } from "./common/ah.mb.common.node-object";

export interface IExportDefinition {
    name: string;
    pathAndName: string;
}

export interface IExportDefinitionSchema {
    nodeVariables: Array<string>;
    nodeTypes: Array<string>;
    rootNodePathAndName: string;
}

export class ExportDefinitionServices {

    private modelServices: modelServices;
    private modelId = "_ExportDefinitions";
    constructor(modelServices: modelServices) {
        this.modelServices = modelServices;
    }

    getExportDefinitions(): Promise<Array<IExportDefinition>> {

            const searchUrl = this.modelServices.getNodeSearchUrl(this.modelId,
                {
                    nodeTypes: ["ExportDefinition"],
                    pathFilter:"\\ExportDefinitions\\"

                });

            return FetchWrapper.fetch(searchUrl, { method: "get" })
                .then(response => response.json())
                .then(response => {

                    var result = response.map(item => {
                        var value: IExportDefinition = {
                            pathAndName: item.name,
                            name: NodeObject.extractName(item.name)
                        };
                        return value;
                    });

                    return result;
                });
    }

    saveExportDefinition(name: string, nodeTypes: Array<string>,
        variableNames: Array<string>): Promise<IBasicCommandResponse> {


        return this.modelServices.createNode(this.modelId,
            "\\ExportDefinitions",
            name,
            "ExportDefinition",
            {
                nodeTypes: nodeTypes,
                nodeVariables: variableNames,
                rootNodePathAndName: ""
            },
            () => {});
    }

    deleteDefinition(definition: IExportDefinition): Promise<IBasicCommandResponse> {
        return this.modelServices.deleteNodes(this.modelId,
            [new NodeObject(definition.pathAndName, "ExportDefinition", false, this.modelId)]);
    }

    renameDefinition(definition: IExportDefinition, newName: string): Promise<IBasicCommandResponse> {
        return this.modelServices.renameNode(this.modelId, definition.pathAndName, newName);
    }

    getDefinition(pathAndName: string): Promise<IExportDefinitionSchema> {
        return this.modelServices.getNodeDataValue(this.modelId,
                pathAndName,
                "Schema")
            .then(response => response as IExportDefinitionSchema);
    }

}


// WEBPACK FOOTER //
// ./ClientApp/scripts/export-definition-services.ts